import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalRedirectService {
  private customLoginImagePath: BehaviorSubject<string | null> = new BehaviorSubject(null);

  set docReferrerImagePath(e: string) {
    this.customLoginImagePath.next(e);
  }

  constructor() { }

  getLoginImgPathSubj() {
    return this.customLoginImagePath.asObservable();
  }

}
